module.exports = __webpack_public_path__ + "img/2025big14.6c55c9c1.jpg";